var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RestConnection_1;
import { JSON, JsonConverter, JsonDiscriminatorValue, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import { Connection, ConnectionType } from '../connection';
import { RestBasedConnectionTypes } from './restAuth';
import { RestAuthCredentialsType } from './restAuthCredentials';
import './restAuthEndpoint'; // force import for JsonSchemaV2
import { RestAuthEndpoint } from './restAuthEndpoint';
import './restAuthPagination'; // force import for JsonSchemaV2
import { restConnectionSchemaValidation } from '../../validations.generated';
export const restConnectionSchema = {
    $id: 'urn:wisepipe-common-connection:RestConnection',
    type: 'object',
    properties: {
        endpoints: {
            type: 'object',
            additionalProperties: {
                $ref: 'urn:wisepipe-common-connection:RestAuthEndpoint'
            }
        },
        pagination: { $ref: 'urn:wisepipe-common-connection:RestAuthPagination' },
        subType: { type: 'string', enum: RestBasedConnectionTypes },
        authType: { type: 'string', enum: Object.values(RestAuthCredentialsType) }
    },
    required: ['endpoints', 'pagination']
};
let RestConnection = RestConnection_1 = class RestConnection extends Connection {
    constructor(connectionID, name, endpoints, pagination, subType, authType) {
        super(connectionID, ConnectionType.Rest, name);
        this.endpoints = endpoints;
        this.pagination = pagination;
        if (subType)
            this.subType = subType;
        if (authType)
            this.authType = authType;
        JSON.validate(this, RestConnection_1);
    }
};
__decorate([
    JsonConverter(new MapConverter(RestAuthEndpoint))
], RestConnection.prototype, "endpoints", void 0);
RestConnection = RestConnection_1 = __decorate([
    JsonSchemaV2(restConnectionSchema, restConnectionSchemaValidation),
    JsonDiscriminatorValue(ConnectionType.Rest)
], RestConnection);
export { RestConnection };
//# sourceMappingURL=restConnection.js.map